import * as React from 'react'
import { useBtcInfo } from '../../general/SatoshiPriceProvider';
import EditableFilterComponent from '../../graph/whole-graph/filters/helpers/EditableFilterComponent';
import { FilterableProperty } from '../../graph/whole-graph/filters/helpers/FilterableProperty';
import FilterNumberInput from '../../graph/whole-graph/filters/helpers/FilterNumberInput';
import { BaseFilterState, SingleFilterState } from '../../graph/whole-graph/filters/helpers/FilterStates';


type Props = {
    onValueChange: (newValue: number) => void,
    initialValue: number
}


const OnchainFeeInput: React.FC<Props> = ({ onValueChange, initialValue }: Props) => {
    const btcInfo = useBtcInfo()
    const defaultValue = initialValue;
    const [value, setValue] = React.useState<number>(defaultValue);
    const [tempValue, setTempValue] = React.useState<number>(defaultValue);
    const [isEdit, setIsEdit] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (btcInfo?.transactionFeesSatPerVByte?.low) {
            commitChange(btcInfo.transactionFeesSatPerVByte.low);
            setTempValue(btcInfo.transactionFeesSatPerVByte.low);
        }
    }, [btcInfo]);


    function commitChange(newValue: number) {
        setValue(newValue);
        onValueChange(newValue);
    }

    function changeEditing(newVal: boolean) {
        if (newVal) {
            setIsEdit(true);
        } else {
            setIsEdit(false);
            const valueChanged = value !== tempValue
            if (valueChanged) {
                commitChange(tempValue);
            }
        }
    }

    return (
        <EditableFilterComponent isEdit={isEdit} onChange={newVal => changeEditing(newVal)}>
            Onchain fee: <FilterNumberInput isEdit={isEdit} value={tempValue} onValueChange={(newValue) => {
                setTempValue(newValue);
            }}
                onEnter={() => changeEditing(false)} 
                suffix="sat/vbyte"
                prefix=""
                autoFocus={true}
                />
        </EditableFilterComponent>
    );
}

export default OnchainFeeInput;



